/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * Get the same material instance depending on a settings object
 */
export class MaterialCache {
    constructor(cacheSize = 100) {
        // tslint:disable:no-any
        this._cache = new Map();
        this._cacheSize = cacheSize;
    }
    getMaterial(parameter, materialFactory) {
        if (this._cache.size > this._cacheSize) {
            this._cache.delete(this._cache.keys().next().value);
        }
        const decorationkey = JSON.stringify(parameter);
        if (this._cache.has(decorationkey)) {
            return this._cache.get(decorationkey);
        }
        const material = materialFactory();
        this._cache.set(decorationkey, material);
        return material;
    }
    clear() {
        this._cache.clear();
    }
}
//# sourceMappingURL=MaterialCache.js.map